<template>
  <div>
    <div
        v-if="context.help && !helpModal"
        :id="`${context.id}-help`"
        :class="context.classes.help"
        v-text="context.help"
    />
    <div v-if="context.help && helpModal"
        :id="`${context.id}-help`"
        :class="context.classes.help">
      <a href="#" @click.prevent="toggleModal()">{{ context.help }}</a>
      <modal
        v-if="this.modalOpen"
        :class="{ 'is-active': modalOpen }"
        v-on:childToParent="toggleModal"
        :title="context.help"
      >
        <div class="content" v-html="helpModal">
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    helpModal: {
      type: [String, Boolean],
      default: false
    }
  },
  methods: {
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    }
  },
  data: function () {
      return {
        modalOpen: false
      }
  }
}
</script>

<style scoped lang="scss">
.modal-content {
  position:relative;
  overflow:unset;
}
button.delete {
  position:absolute;
  top:-1rem;
  right:-1rem;
  display:block;
  height:1rem;
  width:1rem;
  background:#FFF;
  background:#00a7ff;
}
</style>